module.exports = __webpack_public_path__ + "img/calendar-time.6d1c0199.svg";